import { vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fba0dcbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vacancies__name" }
const _hoisted_2 = ["id"]
const _hoisted_3 = ["for"]
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"arrows\" data-v-fba0dcbc><svg width=\"10\" height=\"6\" viewBox=\"0 0 10 6\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-fba0dcbc><path d=\"M1.66669 4.49999L4.8586 1.30808C4.9367 1.22997 5.06334 1.22997 5.14144 1.30808L8.33335 4.49999\" stroke=\"#3284FF\" stroke-width=\"1.5\" stroke-linecap=\"round\" data-v-fba0dcbc></path></svg><svg width=\"10\" height=\"6\" viewBox=\"0 0 10 6\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-fba0dcbc><path d=\"M1.66669 4.49999L4.8586 1.30808C4.9367 1.22997 5.06334 1.22997 5.14144 1.30808L8.33335 4.49999\" stroke=\"#3284FF\" stroke-width=\"1.5\" stroke-linecap=\"round\" data-v-fba0dcbc></path></svg></div><div class=\"select__space\" data-v-fba0dcbc></div>", 2)
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "vacancies__linked" }
const _hoisted_9 = ["id"]
const _hoisted_10 = ["for"]
const _hoisted_11 = { class: "vacancies__linked" }
const _hoisted_12 = ["id"]
const _hoisted_13 = ["for"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "vacancies__privacy" }
const _hoisted_16 = ["id"]
const _hoisted_17 = ["for"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.5 3L4.5 9L1.5 5.57143",
    stroke: "white",
    "stroke-width": "1.5",
    "stroke-linecap": "round"
  })
], -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    action: "POST",
    onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"])),
    class: "form__submit_vacancies"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        onFocus: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleEvent && _ctx.handleEvent(...args))),
        id: 'vacancies__name' + this.count,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
        class: _normalizeClass('vacancies_input' + this.count)
      }, null, 42, _hoisted_2), [
        [_vModelText, _ctx.name]
      ]),
      _createElementVNode("label", {
        for: 'vacancies__name' + this.count,
        class: _normalizeClass('vacancies_label' + this.count)
      }, _toDisplayString(_ctx.getStaticLanguage.formName), 11, _hoisted_3)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass('vacancies__select' + this.count),
      onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addSelect && _ctx.addSelect(...args)), ["stop"]))
    }, [
      _createElementVNode("p", {
        class: _normalizeClass('vacancies__select' + this.count + '_placeholder'),
        ref: "placeholder"
      }, _toDisplayString(_ctx.getStaticLanguage.formPosition), 3),
      _createElementVNode("p", {
        class: _normalizeClass('vacancies__select' + this.count + '_text'),
        ref: "text"
      }, null, 2),
      _hoisted_4,
      _createElementVNode("div", {
        class: _normalizeClass('vacancies__body' + this.count),
        onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allVacancies, (vacancie) => {
          return (_openBlock(), _createElementBlock("p", {
            onClick: _withModifiers(($event: any) => (_ctx.chooseVarient($event, vacancie.name)), ["stop"]),
            class: _normalizeClass('vacancies_options' + this.count),
            key: vacancie.id
          }, _toDisplayString(vacancie.name), 11, _hoisted_6))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allInterns, (vacancie) => {
          return (_openBlock(), _createElementBlock("p", {
            onClick: _withModifiers(($event: any) => (_ctx.chooseVarient($event, vacancie.name)), ["stop"]),
            class: _normalizeClass('vacancies_options' + this.count),
            key: vacancie.id
          }, _toDisplayString(vacancie.name), 11, _hoisted_7))
        }), 128))
      ], 2)
    ], 2),
    _createElementVNode("div", _hoisted_8, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        onFocus: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleEvent && _ctx.handleEvent(...args))),
        id: 'vacancies__linked' + this.count,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.linked) = $event)),
        class: _normalizeClass('vacancies_input' + this.count)
      }, null, 42, _hoisted_9), [
        [_vModelText, _ctx.linked]
      ]),
      _createElementVNode("label", {
        for: 'vacancies__linked' + this.count,
        class: _normalizeClass('vacancies_label' + this.count)
      }, _toDisplayString(_ctx.getStaticLanguage.formLink), 11, _hoisted_10)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        onFocus: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleEvent && _ctx.handleEvent(...args))),
        id: 'vacancies__github' + this.count,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.git) = $event)),
        class: _normalizeClass('vacancies_input' + this.count)
      }, null, 42, _hoisted_12), [
        [_vModelText, _ctx.git]
      ]),
      _createElementVNode("label", {
        for: 'vacancies__github' + this.count,
        class: _normalizeClass('vacancies_label' + this.count)
      }, _toDisplayString(_ctx.getStaticLanguage.formGithub), 11, _hoisted_13)
    ]),
    _createElementVNode("button", {
      class: "add__vacancies",
      disabled: _ctx.name && _ctx.linked && _ctx.developer && _ctx.privacy && _ctx.git ? false : true
    }, _toDisplayString(_ctx.getStaticLanguage.formButton), 9, _hoisted_14),
    _createElementVNode("div", _hoisted_15, [
      _withDirectives(_createElementVNode("input", {
        type: "checkbox",
        id: 'vacancies__privacy' + this.count,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.privacy) = $event))
      }, null, 8, _hoisted_16), [
        [_vModelCheckbox, _ctx.privacy]
      ]),
      _createElementVNode("label", {
        for: 'vacancies__privacy' + this.count,
        class: "check_hover"
      }, _hoisted_19, 8, _hoisted_17),
      _createElementVNode("label", {
        for: 'vacancies__privacy' + this.count,
        class: "vacancies__privacy_label"
      }, [
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.getStaticLanguage.formPrivacy) + " ", 1),
          _createElementVNode("span", {
            onClick: _cache[9] || (_cache[9] = _withModifiers(() => _ctx.setModalPrivacy(true), ["prevent"]))
          }, _toDisplayString(_ctx.getStaticLanguage.formPrivacyMain), 1)
        ])
      ], 8, _hoisted_20)
    ])
  ], 32))
}